export const queryKeys = {
  ADDRESS_COUNTRY: 'ADDRESS_COUNTRY',
  ADDRESS_CITY: 'ADDRESS_CITY',
  ADDRESS_DISTRICT: 'ADDRESS_DISTRICT'
};
